"use client";

import { SignIn } from "@clerk/clerk-react";
import { Logo } from "@/components/brand/Logo";

export default function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="flex flex-col items-center gap-6">
        <Logo size="lg" className="text-primary" />
        <SignIn
          path="/login"
          routing="path"
          afterSignInUrl="/dashboard"
          signUpUrl="/signup"
          appearance={{
            elements: {
              rootBox: "mx-auto",
              card: "bg-card border border-border shadow-lg",
              headerTitle: "text-foreground",
              headerSubtitle: "text-muted-foreground",
              socialButtonsBlockButton: "bg-background border border-border transition-all hover:bg-foreground/[0.03] hover:border-foreground/15 hover:shadow-sm",
              socialButtonsBlockButtonText: "text-foreground",
              formFieldLabel: "text-foreground",
              formFieldInput: "bg-background border-border text-foreground",
              footer: "hidden",
              footerAction: "hidden",
              footerActionLink: "text-primary hover:text-primary/90",
              formButtonPrimary: "bg-primary hover:bg-primary/90",
            },
          }}
        />
      </div>
    </div>
  );
}
